import { useInfiniteQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { DateResolution, GridViewFilters, PagedRequestSortOptions } from '../../../../api/generated/data-contracts';
import { fromMinutes } from '../../../../context/network/http/QueryProvider/helpers/queryHelper';

const getTakeParam = (pageOffset: number, chunkSize: number, overscan: number) => {
    if (pageOffset === 0) {
        // This is the initial call and we want to fill the whole screen,
        // and have another full page after that.
        // chunkSize is roughly equal to screen size
        return chunkSize * 2 + overscan;
    }

    return chunkSize;
};

export const useResourcePlannerData = ({
    currentViewFilters,
    chunkSize,
    overscan,
    queryKey,
    timelineEnd,
    timelineResolution,
    timelineStart,
    sort,
}: {
    chunkSize: number;
    overscan: number;
    currentViewFilters: GridViewFilters | null;
    queryKey: any[];
    timelineEnd: Date;
    timelineStart: Date;
    timelineResolution: DateResolution;
    sort: PagedRequestSortOptions | null;
}) => {
    const query = useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam, signal }) => {
            if (!signal.aborted) {
                return ApiCalls.getResourcePlannerGridPaged(
                    {
                        query: {
                            skip: pageParam,
                            take: getTakeParam(pageParam, chunkSize, overscan),
                            sort,
                        },
                        data: {
                            dateResolution: timelineResolution,
                            end: timelineEnd,
                            start: timelineStart,
                            resourceFilter: currentViewFilters.resources,
                            contractFilter: currentViewFilters.contracts,
                            projectFilter: currentViewFilters.projects,
                        },
                    },
                    { signal },
                ).then(res => res.data);
            }
        },
        getNextPageParam: (lastGroup, allGroups, lastPageParam) => {
            if (!lastGroup.hasMore) {
                return null;
            }
            return lastPageParam + getTakeParam(lastPageParam, chunkSize, overscan);
        },
        initialPageParam: 0,
        enabled: chunkSize !== 0,
        staleTime: fromMinutes(2),
        throwOnError: true,
    });

    return query;
};
